import { useMutation } from '@tanstack/react-query';
import { toast } from '../../../lib/toast';
import { exportTasks } from '../api/tasks';
import type { ExportTasksParams } from '../types';

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function useExportTasks() {
  return useMutation({
    mutationFn: (params: ExportTasksParams) => exportTasks(params),
    onSuccess: (blob) => {
      const date = new Date().toISOString().slice(0, 10);
      downloadBlob(blob, `tasks-report-${date}.xlsx`);
      toast.success('Tasks exported successfully');
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to export tasks');
    },
  });
}
